<template>
  <el-container v-if="init" class="column-container">
    <el-header class="header">
      <el-row class="column-head">
        <el-col :span="24" class="column-head__title-text">
          {{ columnTitle }}
        </el-col>
      </el-row>
    </el-header>
    <el-main>
      <el-divider/>
      <div class="column-content">
        <div v-for="item in columnItemList" :key="item.id" class="column-content_item" @click="handlerClick(item)">
          <el-row class="column-content__item">
            <el-col :span="18" class="column-content-item__title-text">
              <label>{{ item.title }}</label>
            </el-col>
            <el-col :span="6" class="column-content-item__title-image">
              <el-image style="width: 93px;" :src="item.titleFileAbsolutePath" :fit="fit"/>
            </el-col>
          </el-row>
          <el-divider class="el-divider"/>
        </div>
      </div>
    </el-main>
  </el-container>
</template>

<script>

import request from '@/utils/Request'
import columnItemUtil from "@/utils/CollumnItemUtil";

export default {
  name: 'ColumnItemList',
  data() {
    return {
      columnItemList: [],
      columnTitle: '',
      isActive: 1,
      init: false,
      fit: 'contain',
      columnItemContent: '',
    }
  },
  mounted() {
    this.columnTitle = this.$route.query.columnName;
    this.getCreditKnowledgeBarConfig(this.columnTitle);
  },
  methods: {
    handlerClick(item) {
      columnItemUtil.incrementReadQuantity(item);
      this.columnItemContent = {
        columnName: item.columnName,
        title: item.title,
        createTime: item.createTime,
        contentFilePath: item.contentFilePath,
        contentFileAbsolutePath: item.contentFileAbsolutePath,
        titleFileAbsolutePath: item.titleFileAbsolutePath,
        readQuantity: item.readQuantity,
        nextItem: item.nextItem,
        previousItem: item.previousItem,
      }
      if (item.contentLink) {
        if (window.miniprogram){
          this.$router.push({
            name: 'columnItemContent',
            params: {
              columnItemContent: this.columnItemContent
            }
          });
        } else {
          window.location.href = item.contentLink
        }
      } else {
        this.$router.push({
          name: 'columnItemContent',
          params: {
            columnItemContent: this.columnItemContent
          }
        });
      }
    },
    /**
     * 获取征信知识宣传栏配置
     */
    getCreditKnowledgeBarConfig(columnName) {
      request({
        url: '/appointment-manager/creditConfig/getConfig',
        method: 'POST',
        loading: true,
        data: {
          columnName: columnName,
          isActive: this.isActive
        }
      }).then(res => {
        let entries;
        if (res.code === '0000' && res.data && (entries = Object.entries(res.data)).length > 0) {
          entries.forEach(([key, value]) => {
            value.forEach(item => {
              this.columnItemList.push({
                id: item.id,
                createTime: item.createTimeStr,
                columnName: item.columnName,
                serialNumber: item.serialNumber,
                isTop: item.isTop,
                title: item.title,
                titleImagePath: item.titleImagePath,
                titleImageContent: item.titleImageContent,
                titleFileAbsolutePath: item.titleFileAbsolutePath,
                contentFileAbsolutePath: item.contentFileAbsolutePath,
                contentFilePath: item.contentFilePath,
                contentLink: item.contentLink,
                readQuantity: item.readQuantity
              })
            })
          })
          this.init = true;
          columnItemUtil.getNextAndPreviousItem(this.columnItemList);
        } else {
          this.$message.info({
            message: '敬请期待',
            duration: 1500,
            onClose: () => {
              this.$router.back();
            }
          })
        }
      }).catch(err => {
        console.error('err', err)
        this.$message.info({
          message: err,
          duration: 1500,
          onClose: () => {
            this.$router.back();
          }
        })
      })
    },
  }
}
</script>

<style scoped>

.column-container {
  background-color: var(--main-back-color);
}

.header {
  padding-top: 20px;
  padding-bottom: 20px;
}

.column-head__title-text {
  font-size: 1.4rem;
  font-weight: bold;
}

.column-content {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.column-content__item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.column-content-item__title-text {
  font-size: 1.15rem;
  font-weight: 500;
}

</style>
